// src/pages/AdminPage/components/SearchBar.tsx
import { Search } from "lucide-react";

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export default function SearchBar({
  value,
  onChange,
  placeholder = "Qidirish...",
}: SearchBarProps) {
  return (
    <div style={{ flex: 1, minWidth: 200, position: "relative" }}>
      <Search
        size={14}
        style={{
          position: "absolute",
          left: 12,
          top: "50%",
          transform: "translateY(-50%)",
          color: "#475569",
        }}
      />
      <input
        className="search-input"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          width: "100%",
          paddingLeft: 36,
          paddingRight: 12,
          paddingTop: 10,
          paddingBottom: 10,
          background: "#111827",
          border: "1px solid #1E2D45",
          borderRadius: 12,
          color: "#E2E8F0",
          fontSize: 13,
        }}
      />
    </div>
  );
}
